<template>
    <div class="CustomerNav">
        <div class="navItem" @click="chooseNav('/customerManage/myCustomer')" :class="{ active: currentPath === '/customerManage/myCustomer' }">
            <span>我的客户</span>
            <span style="margin-left: 5px;">({{ navNumObj.myCustomerNum || "无" }})</span>
            <i class="el-icon-plus" v-if="currentPath.includes('/customerManage/myCustomer')" @click.stop="toNewArchive"></i>
        </div>
        <div class="line"></div>
        <div class="navItem" v-for="item in saveRecordList" :key="item.key" @click="chooseNav('/customerManage/myCustomer?saveKey='+item.key)" 
             :class="{ active: currentPath === '/customerManage/myCustomer?saveKey='+item.key }">
            <span>{{ item.name }}</span>
            <i class="el-icon-delete" @click.stop="deleteSaveItem(item)"></i>
        </div>
        <div class="line"></div>
        <div class="navItem" @click="chooseNav('/customerManage/seasCustomer')" :class="{ active: currentPath === '/customerManage/seasCustomer' }">
            <span>公海客户</span>
            <span style="margin-left: 5px;">({{ navNumObj.publicCustomerNum || "无" }})</span>
        </div>
        <div class="navItem" @click="chooseNav('/customerManage/perspCustomer')" :class="{ active: currentPath === '/customerManage/perspCustomer' }">
            <span>透视客户</span>
        </div>
        <div class="navItem" @click="chooseNav('/customerManage/dynamic')" :class="{ active: currentPath === '/customerManage/dynamic' }">
            <span>客户动态</span>
            <span style="margin-left: 5px;">({{ navNumObj.followRecordNum || "无" }})</span>
        </div>
        <div class="navItem" @click="chooseNav('/customerManage/recycle')" :class="{ active: currentPath === '/customerManage/recycle' }">
            <span>客户回收站</span>
            <span style="margin-left: 5px;">({{ navNumObj.trashDepotNum || "无" }})</span>
        </div>
    </div>
</template>

<script>
export default {
    props: ["currentPath"],
    data() {
        return {
            navNumObj:{
                myCustomerNum: 0,
                publicCustomerNum: 0,
                followRecordNum: 0,
                trashDepotNum: 0,
            },
            saveRecordList: [],
        };
    },
    methods: {
        chooseNav(index) {
            this.$emit("chooseNav",index);
        },

        //导航标记数量
        getNum(){
            this.$axios.get(`${this.$customerUrl}/Company/GetCustomerMenuNum`).then((res) => {
                const { isSuccess, data } = res;
                if (isSuccess) {
                    this.navNumObj = data;
                    localStorage.setItem("customerNavNum",JSON.stringify(data));
                }
            });
        },

        toNewArchive(){
            this.$emit("newArchive");
        },
        getSearchRecord(){
            this.$axios.post(`${this.$customerUrl}/Company/GetSearchRecord`,{
                type: "private",pageIndex: 1,pageSize: 10,
            }).then((res) => {
                const { isSuccess, data } = res;
                if (isSuccess) {
                    this.saveRecordList = data.datas;
                }
            });
        },
        deleteSaveItem(item){
            this.$confirm('是否删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.get(`${this.$customerUrl}/Company/DeleteSearchRecord?key=${item.key}`).then((res) => {
                    const { isSuccess } = res;
                    if (isSuccess) {
                        this.getSearchRecord();
                    }
                });
            })
            .catch(() => {});
        },

    },
    mounted() {
        this.getSearchRecord();

        if(this.currentPath == "/customerManage/myCustomer"){
            this.getNum();
        }else if(localStorage.customerNavNum){
            this.navNumObj = JSON.parse(localStorage.customerNavNum);
        }else{
            this.getNum();
        }
    },
};
</script>

<style lang="scss" scoped>
@import '@/scss/common.scss';
.CustomerNav {
    width: 200px;
    height: calc(100vh - 140px);
    background: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    .oneClass{
        padding: 5px 15px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        color: #aaa;
    }

    .navItem {
        cursor: pointer;
        padding: 0 15px;
        height: 40px;
        line-height: 40px;
        color: #000;
        font-size: 14px;
        display: flex;
        align-items: center;
        &.active {
            color: #fff;
            background: $themeColor;
        }
        img{
            vertical-align: text-bottom;
            margin-right: 5px;
        }
    }

    .line {
        height: 1px;
        background: #f2f2f2;
    }
    .el-icon-delete{
        margin-left: auto;
        display: none;
    }
    .navItem:hover .el-icon-delete{
        display: block;
    }
    .el-icon-plus{
        margin-left: auto;
    }
}
</style>